module.exports = __webpack_public_path__ + "media/fr_ca_s3_Louise.33c6a816.mp3";